/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { shopContext } from "../../contexts/aniplus";
// import axios from "axios";
//import socketio from 'socket.io-client';
//import $ from 'jquery';
//import socket from 'socket.io-client/lib/socket';

//const socket = socketio.connect('https://socket.aniplustv.com:4100')

class StillItem extends PureComponent {
  _selectStill = () => {
    const { stillSerial, selectStill, thumb } = this.props.childProps;

    selectStill(stillSerial, thumb);
  };
  render() {
    const { selectStillSerial, stillSerial, photo } = this.props.childProps;
    return (
      <Fragment>
        <li
          className={selectStillSerial === stillSerial ? "active" : ""}
          onClick={this._selectStill}
        >
          <img src={photo} />
        </li>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(StillItem));
